"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../../../css/DropIndicator.css");

var DropIndicator = function DropIndicator(_ref) {
  var edge = _ref.edge,
      gap = _ref.gap;
  var className = edge === 'top' ? 'top-edge' : 'bottom-edge';
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "drop-indicator " + className,
      style: {
        '--stroke-color': 'blue',
        '--stroke-width': '2px',
        // Shift line and terminal on the main access to account for gaps between items
        '--main-axis-offset': "calc(-0.5 * (" + gap + " + var(--stroke-width)))",
        // ## Line
        '--line-main-axis-start': 'calc(var(--terminal-radius) + 0px)',
        // ## Terminal
        '--terminal-display': 'block',
        '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
        '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
        // The line is positioned to account for the the terminal (--line-main-axis-start).
        // The terminal is rendered relative to the line (it's a `::before`)
        // We need to pull the terminal backwards so it sits before the start of the line
        '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
        // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
        // so the center of the terminal lines up with the center of the line
        '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
      }
    })
  );
};

DropIndicator.defaultProps = {
  gap: '1px'
};
DropIndicator.propTypes = process.env.NODE_ENV !== "production" ? {
  edge: _propTypes["default"].oneOf(['top', 'bottom']).isRequired,
  gap: _propTypes["default"].string
} : {};

var _default = exports["default"] = DropIndicator;